import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

interface Props {
  playing: boolean;
  onToggle: () => void;
}

export default function PreviewPlaybackOverlay({ playing, onToggle }: Props) {
  return (
    <Tooltip title={playing ? 'Pause video' : 'Play video'}>
      <IconButton
        className="video-preview-playback-overlay"
        aria-label={playing ? 'Pause video preview' : 'Play video preview'}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onToggle();
        }}
        sx={{
          position: 'absolute',
          zIndex: 4,
          left: '50%',
          top: '50%',
          width: 54,
          height: 54,
          color: '#fff',
          backgroundColor: 'rgba(15, 23, 42, 0.72)',
          opacity: 0,
          transform: 'translate(-50%, -50%)',
          transition: 'opacity 120ms ease, background-color 120ms ease',
          '&:hover': { backgroundColor: 'rgba(15, 23, 42, 0.9)' },
          '&:focus-visible': { opacity: 1 },
        }}
      >
        {playing ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>
    </Tooltip>
  );
}
